module.exports = __webpack_public_path__ + "static/media/logo-gertner-horizontalni.e871c488.svg";